import { PopupModal } from './components/PopupModal';
import { ConfirmationModal } from './components/ConfirmationModal';

export const Modals = {
  PopupModal,
  ConfirmationModal,
};
